export default __webpack_public_path__ + "static/NJSOMA 2024 1(2) 70 to 73-ec01e73a16380043b53cca121d010055.pdf";